<template>
    <div>
        <slot :viewed="viewed" :clicked="clicked" />
    </div>
</template>

<script>
import debounce from "../../helpers/debounce";
import {submitYiiForm} from "../../helpers/yii";

export default {
    name: "TrackingZone",

    props: {
        name: {type: String, required: true},
    },

    data() {
        return {
            viewedItems: {},
            pendingViews: [],
            // We build the debounced function here because we have multiple instances of this component on the page
            bufferedTrack: debounce(this.trackViews, 1000),
        };
    },

    inject: ['trackingUrls'],

    watch: {
        pendingViews(newValue) {
            if (newValue.length) {
                this.bufferedTrack();
            }
        },
    },

    methods: {
        clicked(type, item) {
            submitYiiForm(this.trackingUrls.click, {
                events_json: JSON.stringify({type, item, zone: this.name}),
            });
        },

        viewed(type, item) {
            const key = `${type}:${item}`;

            // Only track a single view per item
            if (this.viewedItems.hasOwnProperty(key)) {
                return;
            }

            this.viewedItems[key] = true;
            this.pendingViews.push({type, item, zone: this.name});
        },

        trackViews() {
            if (!this.pendingViews.length) {
                return;
            }

            submitYiiForm(this.trackingUrls.view, {
                events_json: JSON.stringify(this.pendingViews),
            });

            this.pendingViews.splice(0);
        },
    },
}
</script>
